<style lang="scss" scoped>
    @import "../../../../common/styles/var";

    .day30 {
        background: rgba(255, 255, 255, 0.1);
        border: 2px solid rgba(255, 255, 255, 0.5);
        border-radius: 10px;
    }

    h4 {
        font-size: 22px;

        &::before {
            content: '';
            margin-right: 10px;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: white;
        }
    }

    h5 {
        font-size: 20px;
    }

    .rect {
        background: rgba(229, 241, 255, 0.1);
        border: 2px solid rgba(33, 96, 181, 1);
        border-radius: 4px;

        section {
            font-size: 26px;
            color: $mainColor;
        }
    }

    .circle {
        margin-left: 20px;
        width: 140px;
        height: 140px;
        border-radius: 50%;

        section {
            font-size: 20px;
        }
    }

    .circle1 {
        background: rgba(0, 195, 98, 0.3);
        border: 2px solid rgba(0, 195, 98, 0.5);

        section {
            color: rgba(0, 195, 98, 1);
        }
    }

    .circle2 {
        background: rgba(255, 222, 0, 0.3);
        border: 2px solid rgba(255, 222, 0, 0.5);

        section {
            color: rgba(255, 222, 0, 1);
        }
    }

    .circle3 {
        background: rgba(255, 0, 246, 0.3);
        border: 2px solid rgba(255, 0, 246, 0.5);

        section {
            color: rgba(255, 0, 246, 1);
        }
    }

    .day30-zc, .day30-zr {
        padding: 15px 30px;
        width: 49%;
        background: rgba(255, 255, 255, 0.1);
        border: 2px solid rgba(255, 255, 255, 0.5);
        border-radius: 10px;

        dl {
            justify-content: space-around;
        }

        section {
            margin-top: 2px;
            height: 10px;
            background: rgba(57, 67, 144, 1);
            opacity: 0.5;
            border-radius: 5px;
        }
    }

    .day30-zc {
        section {
            div {
                height: 10px;
                background: linear-gradient(270deg, rgba(255, 102, 102, 1), rgba(220, 0, 0, 1));
                border-radius: 5px;
            }
        }
    }

    .day30-zr {
        margin-left: 2%;

        section {
            div {
                height: 10px;
                background: linear-gradient(270deg, rgba(130, 188, 255, 1), rgba(67, 154, 255, 1));
                border-radius: 5px;
            }
        }
    }

    .line {
        background: rgba(255, 255, 255, 0.1);
        border: 2px solid rgba(255, 255, 255, 0.5);
        border-radius: 10px;
    }
</style>
<template>
    <div class="flex row">
        <div class="left-container flex column">
            <div class="day30 flex0 pl30 pr30 pt15 pb15">
                <h4 class="flex aic">最近30天急救运行情况</h4>
                <div class="flex mt10">
                    <div class="rect flex column aic pl15 pr15 pt10 pb10">
                        <h5>急救转诊例数</h5>
                        <section class="mt10">{{data.emergencyReferralOrderLastMonCount}}</section>
                        <p class="fs18 mt10">累计{{data.emergencyReferralOrderCount}}例</p>
                    </div>
                    <div class="rect ml20 flex column aic pl15 pr15 pt10 pb10">
                        <h5>参与急救机构</h5>
                        <section class="mt10">{{data.settledInLastMonHosCount}}</section>
                        <p class="fs18 mt10">共入驻{{data.settledInHosCount}}家</p>
                    </div>
                    <div class="rect ml20 flex column aic pl15 pr15 pt10 pb10">
                        <h5>急救里程</h5>
                        <section class="mt10">12310km</section>
                        <p class="fs18 mt10">累计25.45万km</p>
                    </div>
                    <div class="circle circle1 flex aic jcc column">
                        <h5>平均响应时间</h5>
                        <section>{{data.avgResponseTimeDescription}}</section>
                    </div>
                    <div class="circle circle2 flex aic jcc column">
                        <h5>平均接送时间</h5>
                        <section>{{data.avgDeliveryTimeDescription}}</section>
                    </div>
                    <div class="circle circle3 flex aic jcc column">
                        <h5>平均费用</h5>
                        <section>{{data.avgcost/100}}元</section>
                    </div>
                </div>
            </div>
            <div class="flex1 flex pt15 pb15">
                <div class="day30-zc flex column">
                    <h4 class="flex0 flex aic">最近30天急诊转出排行榜</h4>
                    <dl class="flex1 flex column">
                        <dd class="flex0 flex aic" v-for="(data,idx) in data.initEmergencyCountList" :key="idx">
                            <label class="idx fs24">{{idx+1}}.</label>
                            <div class="flex1">
                                <p class="flex fs16">
                                    <span class="flex1">{{data.initHosName}}</span>
                                    <span>{{data.emergencyCount}}例</span>
                                </p>
                                <section class="flex mt5">
                                    <div :style="{width:`${(idx+1)/7*100}%`}"></div>
                                </section>
                            </div>
                        </dd>
                    </dl>
                </div>
                <div class="day30-zr flex column">
                    <h4 class="flex0 flex aic">最近30天急诊转入排行榜</h4>
                    <dl class="flex1 flex column">
                        <dd class="flex0 flex aic" v-for="(data,idx) in data.hopeEmergencyCountList" :key="idx">
                            <label class="idx fs24">{{idx+1}}.</label>
                            <div class="flex1">
                                <p class="flex fs16">
                                    <span class="flex1">{{data.hopeHosName}}</span>
                                    <span>{{data.emergencyCount}}例</span>
                                </p>
                                <section class="flex mt5">
                                    <div :style="{width:`${(idx+1)/7*100}%`}"></div>
                                </section>
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <div class="right-container flex1 ml15 flex column pb15">
            <zj-map></zj-map>
            <div class="line mt15 flex0 pt15 pb15 pl30 pr30">
                <h4 class="flex aic">近一年急救转诊数量</h4>
                <line-echarts :list="data.emergencyMonCountList"></line-echarts>
            </div>
        </div>
    </div>
</template>
<script>
  import LineEcharts from "../../components/daping/line-echarts";
  import {staffService} from "../../service/staff";
  import ZjMap from "../../components/daping/zj-map";

  export default {
    name: 'jijiu-daping-total',
    components: {ZjMap, LineEcharts},
    data() {
      return {
        data: {}
      }
    },
    created() {
      this.getData();
    },
    methods: {
      async getData() {
        this.data = await staffService.count();
      }
    },
  }
</script>
